// extracted by mini-css-extract-plugin
export default {"header_wrapper":"ActivityTemp_header_wrapper__ORDJA"};